import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";

@Component({
  selector: "app-corporateAdmin",
  templateUrl: "./corporateAdmin.component.html",
  styleUrls: ["./corporateAdmin.component.css"]
})
export class CorporateAdminComponent implements OnInit {
  baseUrl: any = environment.apiUrl;
  user: any = {};
  duplicateEmailErrorMessage: any = "";
  duplicateEmailError: boolean = false;
  duplicateMobileErrorMessage: any = "";
  duplicateMobileError: boolean = false;
  customerId: number;

  constructor(
    private service: CommonHttpService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.route.queryParams.subscribe(params => {
      this.user.ReferralId = Number(params["referralId"]);
    });
  }

  signup() {
    this.router.navigate(["./corporatesignup"]);
  }

  checkDuplicateEmail() {
    this.service
      .get(
        this.baseUrl +
          "ESignUpAPI/IsEmailOrMobileNoAvailable/" +
          this.user.Email
      )
      .subscribe(
        data => {
          console.log(data);
          if (data != true) {
            this.duplicateEmailErrorMessage = data;
            this.duplicateEmailError = true;
          } else {
            this.duplicateEmailErrorMessage = "";
            this.duplicateEmailError = false;
          }
        },
        error => {
          this.loaderService.display(false);
        }
      );
  }

  checkDuplicateMobile() {
    this.service
      .get(
        this.baseUrl +
          "ESignUpAPI/IsEmailOrMobileNoAvailable/" +
          this.user.MobileNumber
      )
      .subscribe(
        data => {
          console.log(data);
          if (data != true) {
            this.duplicateMobileErrorMessage = data;
            this.duplicateMobileError = true;
          } else {
            this.duplicateMobileErrorMessage = "";
            this.duplicateMobileError = false;
          }
        },
        error => {
          this.loaderService.display(false);
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/CorporateAdmin/corporateAdmin.component.ts